export default {
  name: 'survey',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    this.$store.dispatch('Survey/showSurvey', {survey_id: this.$route.params.survey_id})
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/views/survey/survey.js